import { AppSettings } from './app.settings';
export class ProductPriceSettings{
    public static PERSON_TYPES = `${AppSettings.BASE_URL}/api/person-types/:id`;
    public static PRODUCT_AVAILABILITY = `${AppSettings.BASE_URL}/api/availability/:id`;
} 